import { useMutation } from "@tanstack/react-query";
import { SupportFormValues } from "../../components/ui/modals/support.modal.component";
import { formSubmissionService } from "../service/forms.submission.service";

export function useCreateFeedback() {
    return useMutation({
        mutationKey: ["create feedback"],
        mutationFn: (data: SupportFormValues) => formSubmissionService.submitFeedback(data),
    });
}